
import { View, ScrollView, FlatList, Dimensions, Pressable, useColorScheme } from 'react-native';
import { Text, Divider, Chip, Button, HelperText, ActivityIndicator, FAB, IconButton, TextInput, } from 'react-native-paper';
import * as React from 'react';
import { useTheme } from 'react-native-paper';

import { Badge } from 'react-native-paper';
import { batch, useDispatch, useSelector } from "react-redux";
import DImage from "../components/DImage"
import Global from "../constants/global";
import ImportStudentData from "../components/ImportStudentData";
import Preferance from '../constants/Preferances';
import { arrayUnion, collection, doc, getDoc, getDocs, getFirestore, limit, onSnapshot, orderBy, query, setDoc, updateDoc, where, writeBatch } from "firebase/firestore";
import { listsTask } from '../task/listTasks';
import StudentPlainRow from '../components/StudentRowPlain';
import DChip from '../components/DChip';
import { FontAwesome5, MaterialCommunityIcons } from '@expo/vector-icons';
import { TouchableOpacity } from 'react-native-gesture-handler';
import { list, ref } from 'firebase/storage';
import { useRoute } from '@react-navigation/native';

import DModal from '../components/DModal';

export default function PrepareMarks({ navigation, route }) {
    const [subjects, setSubjects] = React.useState([])
    const [data, setData] = React.useState({ std: undefined, exam: undefined, year: 0, classStudents: [], loading: true })
    const [connected, setConnected] = React.useState({ connection: -1, locked: true, lockStatus: undefined })

    const s = useSelector(s => s.list.Subjects)
    const classStudents = useSelector(s => s.list.Students);

    const { colors } = useTheme();
    const pref = React.useContext(Preferance)
    React.useEffect(() => {
        const ex = route.params.exam?.forClass.find(f => route.params.std.id == f.classId)

        const ns: [] = []
        const es = route.params.subjects
        ex?.subjects?.map(s => {
            const got = es.find(ei => ei.id == s.id)
            const t = got?.teacher ? got?.teacher : {}

            ns.push({ ...s, teacher: t })
        })
        const ns1 = Global.sortSubjects(ns)
        setSubjects(ns1)
    }, [s, route.params.subjects])

    // HERE TAKEN STUDENTS SERVER, PASSED TO DUMP DUMP, SORTED AND SEND TO STUDENT CHIP FOR RETRIVAL OF MARKS AND DISPLAY

    // CHECK IS NET CONNECTED
    React.useEffect(() => { Global.checkNet().then(e => setConnected({ connection: e, locked: route?.params?.lockStatus?.locked, lockStatus: route?.params?.lockStatus })) }, [])

    // GET STUDENTS FROM DUMP
    React.useEffect(() => {
        if (data?.std?.id) {
            const yr = route.params?.year
            const st: [] = []
            classStudents.map(m => {
                if (m[`class${yr}`]?.classId == data?.std?.id + "") {
                    if (m?.flag !== -10) {
                        st.push(JSON.parse(JSON.stringify(m)))
                    }
                }
            })
            let sortedSt = Global.sortStudent(st, yr)
            ////console.log("sortedSt", sortedSt)
            setData(p => ({ ...p, classStudents: sortedSt }))
        }
    }, [classStudents])

    React.useEffect(() => {
        return () => {
            setSubjects([])
            setData({ std: undefined, exam: undefined, year: 0, classStudents: [], loading: true })
            setConnected({ connection: -1, locked: true })
        }
    }, [])
    //console.log(connected.connection)

    return (
        <View style={{ flex: 1, paddingLeft: 10 }}>
            <ScrollView>

                {connected.connection ? <View style={{ backgroundColor: colors.background, flex: 1, justifyContent: "center" }}>
                    <ImportStudentData classId={route?.params?.std?.id} year={route?.params?.year} Update={() => {
                        setData(p => ({
                            ...p,
                            classStudents: [],
                            std: route?.params?.std,
                            exam: route?.params?.exam,
                            year: route?.params?.year,
                            loading: false
                        }))
                    }} />

                    <View style={{ backgroundColor: "white", alignSelf: "stretch" }}>
                        <DImage uri="https://img.freepik.com/premium-vector/cute-little-boy-feel-happy-because-get-good-grade-from-exam_97632-4655.jpg" />
                    </View>
                    <View style={{ paddingLeft: 20 }}>
                        <View style={{ flexDirection: "row", backgroundColor: "transparent" }}>
                            <Text style={{ alignSelf: "stretch", textAlign: "center" }} variant="headlineSmall">{data.exam?.name ? data.exam?.name : ""} - {route?.params?.std?.name} {route?.params?.std?.div ? route?.params?.std?.div : ""} </Text>
                            <ActivityIndicator animating={connected.connection == -1 || data.loading} />
                        </View>

                        {connected.locked && <Text>Result is Locked</Text>}

                        <View>
                            {subjects?.length && !data.exam?.final && <SubjectList allExams={route.params?.allExams} students={data.classStudents} current={pref} data={data} navigation={navigation} examSubjects={subjects} year={route?.params?.year} classId={route?.params?.std?.id} exam={route.params.exam} std={route.params.std} locked={connected.locked} lockStatus={connected.lockStatus} />}
                            <Text variant="titleLarge">{data.exam?.final ? "" : connected.locked ? "" : "To insert Subjectwise marks click on Subject below "}</Text>
                            {/* {//console.log("isFinal ? ", data.exam?.final)} */}
                            {data.exam?.final && <FinalAll
                                data={data}
                                dark={false}
                                current={pref}
                                allExams={route.params?.allExams}
                                navigation={navigation}
                                subjects={subjects}
                                year={route?.params?.year}
                                classId={route?.params?.std?.id}
                                exam={route.params.exam}
                                std={route.params.std} />}
                        </View>
                    </View>
                    <Divider />
                </View> : <Text variant="titleMedium" style={{ flex: 1, textAlign: "center", color: "red" }}>{connected.connection == 0 ? "Checking Connection" : "Internet Connection issue !"}</Text>}

            </ScrollView>
        </View >
    )

}
async function SaveAndLock({ navigation, classStamp, current, exam, year, idata, reports, std, finalData }) {
    try {
        const db = getFirestore()
        const ref = doc(db, Global.RESULTREPORT, classStamp)
        console.log("current", current)
        const data = {
            id: ref.id,
            savedBy: { id: current?.current?.id, name: current?.current?.name },
            stamp: new Date().getTime(),
            classStamp: classStamp,
            locked: true,
        }
        if (finalData) {

        } else {
            if (exam?.isInternal) {
                data.InternalReport = idata
                data.isInternal = true
            } else {
                data.Tarij = reports.tarij
                data.SubjectSheet = reports.SubSheet
                data.SummarySheet = reports.SummSheet
                data.Marksheets = reports.Marksheets
            }
            data.isInternal = exam?.isInternal ? exam?.isInternal : false

        }
        data.classStamp = classStamp
        data.classYearStamp = std.id + year
        if (exam?.exam) {
            data.examNo = exam?.exam
        }
        if (exam?.final) {
            data.final = exam?.final
        }
        await SaveMarksLog({ current, data })

        data.id = ref.id
        await setDoc(ref, data)

        const backUpref = doc(collection(db, Global.RESULTLOG))
        const bd = { ...data }
        bd.id = backUpref.id
        await setDoc(backUpref, data).then(e => {
            alert("Result is now LOCKED.")

            if (navigation?.canGoBack()) {
                navigation.goBack()
            }
        }).catch(e => {
            alert("Error")
        })
        return 1
    } catch (e) {

        alert("Error: Saving Result: Press back button and Check if you have any subject without Teacher assigned, and try again later")
    }
}
async function Unlock({ classStamp, navigation }) {
    const db = getFirestore()
    const ref = doc(db, Global.RESULTREPORT, classStamp)
    // , unlockedBy: `Unlocked by ${current?.current?.name} on ${day}/${month}/${year}` 
    await setDoc(ref, { locked: false }, { merge: true }).then(e => {
        alert("Result is now UNLOCKED.")
        if (navigation?.canGoBack()) {
            navigation.goBack()
        }
    }).catch(e => {
        alert("Error")
    })

}

const SaveGeneratedReports = ({ exam, std, year, reports, disabled, current, lockStatus, marks, navigation }) => {
    const [wait, setWait] = React.useState(false)
    const classStamp = exam.name + std.id + year
    const idata = useSelector(s => s.list.InternalSummary[std?.id + year + exam.name])


    return <View style={{ flexDirection: "row" }}> {lockStatus?.locked ?
        <DChip disabled={disabled} onPress={() => {
            setWait(true)
            Unlock({ classStamp, navigation }).then(e => {
                setWait(false)
            })
        }} >Unlock Result</DChip>
        : <DChip disabled={disabled} onPress={() => {
            setWait(true)
            SaveAndLock({ navigation, classStamp, current, exam, year, idata, reports, std, finalData: false }).then(e => {
                setWait(false)
            })
        }} >Lock & Finalize Result</DChip>
    }
        <ActivityIndicator animating={wait} />
    </View>
}


const LoadMarksFromServer = ({ students, std, exam, year }) => {
    const dispatch = useDispatch()

    React.useEffect(() => {
        const db = getFirestore()
        const citiesRef = collection(db, Global.MARKS)
        // const unsubscribeMap = {}

        //        const sid = student.id + std.id + exam.name + year
        const q = query(citiesRef, where("stdId", "==", std.id), where("examId", "==", exam.name), where("year", "==", year))
        const unsub = onSnapshot(q, { includeMetadataChanges: true }, (docc) => {

            const recdStudents: [] = []
            docc.docChanges().forEach((change) => {
                const d = change.doc.data()
                recdStudents.push(d)
            })
            students.map(s => {
                const me = {}
                const muSubjects = recdStudents.filter(f => s.id == f.studentId)

                if (muSubjects.length) {
                    muSubjects.map(d => {
                        me[d.id] = d
                    })
                    ////console.log("ME", me)
                    const classId = s["class" + year]?.classId
                    const examClass = exam.forClass.find(e => e.classId == classId)
                    const cid = Global.StudentExamYearId({ student: s, exam: exam, std: std, year: year })


                    dispatch(listsTask.actions.updateMarks({
                        type: Global.MARKS,
                        examName: exam.name,
                        data: me,
                        cid: cid,
                        classId,
                        student: s,
                        examClass,
                        year
                    }))
                }
            })
            ////console.log("fromCache", recdStudents)

            if (!docc.metadata.fromCache || docc.empty) {
                //console.log("received")

                dispatch(listsTask.actions.setDataReceived({ received: true }));
            }
            // recdStudents.map(d => {
            //     const student = students.find(f => f.id == d.studentId)


            // })
            // setMarksMap(prev => ({ ...prev, [student.id]: me }))
        })

        return () => unsub()
    }, [students, exam, year])

    return <></>
}
const SubjectList = ({ allExams, data, navigation, examSubjects, year, exam, std, current, locked, lockStatus, students }) => {

    const [selected, setSelected] = React.useState()
    const wholeMarks = useSelector(s => s.list.Marks) // DUMP FOR STUDENT MARKS
    const WholeMarksLoaded = useSelector(s => s.list.WholeMarksLoaded) // DUMP FOR STUDENT MARKS
    const classStamp = exam?.name + std?.id + year
    const mess = useSelector(s => s.list.ExamMessages[classStamp ? classStamp : "und"])
    const stvm = useSelector(s => s.list.stvm) // DUMP FOR STUDENT MARKS
    const [marks, setMarks] = React.useState() // DUMP FOR STUDENT MARKS
    const [preparedSubjects, setPreparedSubjects] = React.useState({ subjects: undefined, reports: undefined })
    const [ready, isReady] = React.useState({ loaded: false, options: false })
    const dispatch = useDispatch()


    React.useEffect(() => {
        // //console.log("wholeMarks",locked, Object.keys(wholeMarks).length, data.classStudents.length)

        if (!locked) {
            // const d = {}
            // try {
            //     //console.log("wholeMarks", Object.keys(wholeMarks).length)
            //     Object.keys(wholeMarks).forEach(function (key, index) {
            //         if (wholeMarks[key].Summary.student["class" + year].classId == std.id + "") {
            //             d[key] = wholeMarks[key]
            //         }
            //     })
            // } catch { }
            ////console.log("wholeMarks", wholeMarks)
            setMarks(prev => (prev === wholeMarks ? prev : wholeMarks))
        }

        return () => {
            // clearTimeout(handle)
        }
    }, [wholeMarks])


    React.useEffect(() => {
        if (!locked) {
            if (WholeMarksLoaded && marks) {
                const usr: any[] = []; // Changed to any[] to allow pushing items
                const markKeysByEid = {};

                // 1. Process existing marks
                Object.keys(marks).forEach(function (key) {
                    try {
                        const currentMarks = marks[key];
                        const eid = Global.StudentExamYearId({
                            student_id: currentMarks?.Summary?.student?.id,
                            exam: exam,
                            year: year,
                            std: std
                        });
                        if (key == eid) {
                            usr.push({ ...currentMarks, key: key });
                            markKeysByEid[eid] = new Set(Object.keys(currentMarks));
                        }
                    } catch (e) { }
                });

                // 2. Add 'Left' students not already in usr (Performance optimized with Set)
                const existingKeys = new Set(usr.map(u => u.key));
                students.forEach(st => {
                    const eid = Global.StudentExamYearId({ student_id: st.id, exam, year, std });
                    if (!existingKeys.has(eid) && Global.isLeft(st, year)) {
                        usr.push({
                            Summary: {
                                student: st,
                                status: "Left",
                                totalGained: 0
                            },
                            ["class" + year]: st["class" + year],
                            key: eid
                        });
                    }
                });

                const mySubjects = [];
                examSubjects?.forEach((t) => {
                    let streamStd = [];
                    const show = t?.totalMarks > 0;
                    try {
                        const sstream = t?.stream ? t?.stream : 0;
                        streamStd = students.filter(f => {
                            const stream = f["class" + year]?.stream ? f["class" + year]?.stream : 0;
                            return ((sstream == 0) || (stream == sstream)) && t?.totalMarks > 0;
                        });
                    } catch (e) { }

                    if (show) {
                        let has = 0;
                        let okPending = 0;
                        streamStd.forEach(student => {
                            try {
                                if (!Global.isLeft(student, year)) {
                                    const eid = Global.StudentExamYearId({ student: student, exam: exam, std: std, year: year });
                                    if (markKeysByEid[eid]?.has(eid + t.id)) {
                                        has++;
                                    } else {
                                        okPending++;
                                    }
                                }
                            } catch (e) { }
                        });
                        mySubjects.push({ subject: t, students: streamStd, pending: okPending });
                    }
                });

                const data1 = [...usr].sort((a, b) => (b?.Summary?.totalGained || 0) - (a?.Summary?.totalGained || 0));
                let topMark = 10000;
                let rank = 0;
                const rankList: any[] = [];

                data1.forEach(e => {
                    const pass = e.Summary?.status == "Pass" || e.Summary?.status == Global.PASS;
                    if (pass && e["class" + year]?.left !== true) {
                        if (topMark == e.Summary?.totalGained) {
                            rankList.push({ rank: rank, key: e.key });
                        } else if (topMark > e.Summary?.totalGained) {
                            topMark = e.Summary?.totalGained;
                            rank++;
                            rankList.push({ rank: rank, key: e.key });
                        }
                    }
                });

                if (rankList.length) {
                    dispatch(listsTask.actions.updateRank({ data: rankList }));
                }

                // PREPARING REPORTS
                let classStudents = data1;
                let subjectList = examSubjects?.filter(f => f.totalMarks > 0).map(f => ({ ...f }));

                let consAttent = 0;
                let tstudent = classStudents?.length;
                let Oattend = 0, Opass = 0, Ofail = 0, Oleft = 0, Ototal = 0, Oabsent = 0, Onotprepared = 0;

                classStudents.forEach((student, i) => {
                    let result = student?.Summary;
                    if (result) {
                        result = { ...result, seq: i };
                        Ototal++;
                        if (Global.isLeft(student, year)) {
                            Oleft++;
                        } else {
                            if (result?.theory == "Absent") {
                                Oabsent++;
                            } else {
                                const status = Global.getResultStatus(result?.status);
                                if (status == "Pending") {
                                    Onotprepared++;
                                } else {
                                    if (status == "Fail") { Ofail++; Oattend++; }
                                    if (status == "Pass") { Opass++; Oattend++; }
                                }
                            }
                        }
                    }
                });

                subjectList = subjectList.map((s, i) => {
                    let attend = 0, pass = 0, fail = 0, left = 0, total = 0, absent = 0, notprepared = 0;
                    classStudents.forEach(student => {
                        const id = Global.genSubId({ studentId: student.Summary.student.id, classId: std.id, examId: exam.name, year: year, subjectId: s.id });
                        const result = student?.[id];
                        if (result) {
                            total++;
                            if (Global.isLeft(student, year)) {
                                left++;
                            } else {
                                if (result.theory == "Absent") {
                                    absent++;
                                } else {
                                    const status = Global.getResultStatus(result.status);
                                    if (status == "Pending") {
                                        notprepared++;
                                    } else {
                                        if (status == "Fail") { fail++; attend++; }
                                        if (status == "Pass") { pass++; attend++; }
                                    }
                                }
                            }
                        }
                    });
                    if (attend > consAttent) consAttent = attend;
                    return { ...s, attend, pass, fail, left, total, absent, pending: notprepared };
                });

                const ranklist = classStudents?.filter(f => {
                    const r = f?.Summary?.rank;
                    return r !== 0 && r !== undefined && r <= 5;
                }).sort((a, b) => (a?.Summary?.rank || 0) - (b?.Summary?.rank || 0));

                const passCount = classStudents?.filter(f => Global.getResultStatus(f?.Summary?.status) == "Pass" && f.left !== true)?.length;
                const failCount = classStudents?.filter(f => Global.getResultStatus(f?.Summary?.status) == "Fail" && f.left !== true)?.length;
                const leftCount = classStudents?.filter(f => Global.isLeft(f, year))?.length;

                const sheet = classStudents.map(m => ({ student: m, examObject: exam, subject: subjectList }));

                const data = {
                    year, sheet, subjects: subjectList, class: { ...std }, student: classStudents, exam: { ...exam },
                    totalStudents: tstudent, attend: consAttent, pass: passCount, fail: failCount, ranklist, left: leftCount,
                    overAll: { pass: Opass, fail: Ofail, total: Ototal, absent: Oabsent, attend: Oattend }
                };

                const rSubject = data.subjects.map(ss => {
                    const rx = Math.round((ss.pass * 100) / ss.attend);
                    return {
                        subName: ss.name,
                        teacherName: ss?.teacher?.teacherName,
                        attend: ss.attend,
                        pass: ss.pass,
                        result: (isNaN(rx) ? "" : rx) + "%"
                    };
                });

                const rnkList = ranklist.map((s) => ({
                    rank: s.Summary?.rank,
                    roll: s.Summary.student["class" + data.year]?.roll,
                    name: s.Summary.student.name,
                    marks: s?.Summary?.selfMarks,
                    pc: s?.Summary?.pc + "%"
                }));

                const tarij = {
                    examName: data.exam?.name,
                    className: data.class?.name,
                    div: data.class?.div,
                    year: Global.YearString(data.year + ""),
                    totalStudentCount: (data?.overAll?.total - data.left),
                    examSeatCount: data?.overAll?.attend,
                    passCount: data?.overAll?.pass,
                    failCount: data?.overAll?.fail,
                    percentResult: Math.round((data?.overAll?.pass * 100) / (data?.overAll?.total - data.left)) + "%",
                    settingPercentResult: Math.round((data.overAll?.pass * 100) / data.overAll?.attend) + "%",
                    subjectResult: rSubject,
                    rankList: rnkList,
                };

                const sNames = [];
                data.subjects?.forEach(ss => {
                    const dtosend = data?.sheet?.filter(e => e?.totalling !== true);
                    const addSubSheet = (isPractical) => {
                        const th = PerformSummarySheet(dtosend, year, ss, exam, isPractical);
                        sNames.push({
                            name: ss.name + (isPractical ? " Practical" : (ss.practical ? " Theory" : "")),
                            marks: ss.totalMarks,
                            students: th,
                            theory: !isPractical,
                            practical: isPractical,
                            totalMarks: isPractical ? ss?.practicalMarks : (ss.practical ? ss?.theoryMarks : ss?.totalMarks),
                            pass: ss.pass, fail: ss.fail, absent: ss.absent,
                            total: ss.fail + ss.pass + ss.absent,
                            pc: Math.round((ss.pass * 100) / (ss.fail + ss.pass)) + "%"
                        });
                    };
                    addSubSheet(false);
                    if (ss.practical) addSubSheet(true);
                });

                const SubjectSheet = {
                    examName: data.exam?.name, className: data.class?.name,
                    div: data.class?.div, year: Global.YearString(data.year + ""),
                    subjectList: sNames,
                };

                const onlySubNamesList = data.subjects.map(sub => ({ id: sub.id, name: sub.name }));
                const sList = usr.map(value => {
                    const student = value?.Summary?.student;
                    const subMarks = {};
                    onlySubNamesList.forEach(sub => {
                        const id = Global.genSubId({ studentId: student.id, classId: std.id, examId: exam.name, year, subjectId: sub.id });
                        subMarks[sub.id] = {
                            marks: value?.[id] ? Global.getDoubleZero(Global.getValue(value?.[id], "Ab")) : "",
                            practical: value?.[id]?.practical || "",
                            status: value?.[id]?.status ?? "",
                            name: sub.name
                        };
                    });
                    return {
                        roll: student["class" + data.year]?.roll,
                        name: Global.getStudentName(student, data.year),
                        gr: Global.getGR(student, data.year),
                        status: Global.getResultStatus(value?.Summary?.status),
                        subjectMarks: subMarks,
                        left: Global.isLeft(student, data.year) || false,
                        totalMarks: value?.Summary?.totalGained,
                        rank: value?.Summary?.rank ?? ""
                    };
                });

                const SummarySheet = {
                    examName: data.exam?.name, className: data.class?.name,
                    div: data.class?.div, year: Global.YearString(data.year + ""),
                    subjectNames: onlySubNamesList,
                    studentList: sList.sort((a, b) => a?.roll - b?.roll)
                };

                const Marksheets = {};
                usr.forEach(value => {
                    let subject = [];
                    const student = value?.Summary?.student;
                    let outOf = 0;
                    try {
                        Object.keys(value).forEach(key => {
                            if (key !== "Summary" && value[key]?.subjectId) {
                                subject.push(value[key]);
                                if (!value[key]?.subject?.grad) {
                                    outOf += (value[key]?.subject?.totalMarks || 100);
                                }
                            }
                        });
                        const missingSubs = examSubjects?.filter(s => {
                            if (s?.totalMarks > 0) {
                                const stream = student["class" + year]?.stream || 0;
                                const sstrem = s.stream || 0;
                                return (stream == sstrem || sstrem == 0) && !subject.find(stSub => stSub.subject.id == s.id);
                            }
                            return false;
                        });
                        missingSubs.forEach(a1 => {
                            subject.push({ theory: "Pending", subject: a1, status: "Pending" });
                            outOf += a1.totalMarks;
                        });
                        subject.sort((a, b) => (a?.subject?.order || 0) - (b?.subject?.order || 0));
                    } catch (e) { }

                    const PASS_VAL = (value?.Summary?.status == "Pass" || value?.Summary?.status == Global.PASS);
                    let cnd = 0;
                    const marksData = subject.map(SUB => {
                        const toShow = (SUB?.subject?.totalMarks > 0 || SUB?.subject?.grad);
                        if (toShow) cnd++;
                        return {
                            sr: cnd,
                            name: SUB.subject.name,
                            marks: SUB?.subject?.grad ? "" : (exam?.final ? 100 : SUB.subject?.totalMarks),
                            status: SUB?.status,
                            theory: SUB?.theory,
                            grad: SUB?.grad || false,
                            internal: SUB?.internal ?? "",
                            practical: SUB?.practical ?? "",
                            siddhi: SUB?.subject?.siddhi || "",
                            kripa: SUB?.subject?.kripa || "",
                            totalMarks: SUB?.subject?.totalMarks,
                        };
                    });

                    const clid = student?.["class" + year]?.classId;
                    Marksheets[student.id] = {
                        examName: exam?.final ? "વાર્ષિક પરીક્ષાનું" : exam?.name,
                        year: Global.YearString(year),
                        name: student?.["class" + year]?.name || student?.name,
                        class: student?.["class" + year]?.class,
                        div: student?.["class" + year]?.div || clid?.replace(/[0-9]/g, ''),
                        roll: student?.["class" + year]?.roll,
                        gr: Global.getGR(student, year),
                        uid: student?.uid || student?.["class" + year]?.uid || student?.["class" + (year - 1)]?.uid || "",
                        final: exam?.final || false,
                        marks: marksData,
                        note1: [1, 2, 3].includes(value?.Summary?.rank) ? "Congratulations" : "",
                        note2: mess?.message || "",
                        status: exam?.final ? (PASS_VAL ? (exam?.kripaGiven > 0 ? "ઉપર ચઢાવ્યા" : Global.getResultStatus(value?.Summary?.status)) : Global.getResultStatus(value?.Summary?.status)) : Global.getResultStatus(value?.Summary?.status),
                        pc: PASS_VAL ? (value?.Summary?.pc || "") : "",
                        totalGained: value?.Summary?.totalGained ?? "",
                        rank: value?.Summary?.rank > 0 ? value?.Summary?.rank : "",
                        totalMarks: value?.Summary?.totalMarks ?? 0
                    };
                });

                setPreparedSubjects({ subjects: mySubjects, reports: { tarij, SubSheet: SubjectSheet, SummSheet: SummarySheet, Marksheets } });
                dispatch(listsTask.actions.setReports({ classId: std.id, year, examName: exam.name, tarij, SubSheet: SubjectSheet, SummSheet: SummarySheet, Marksheets }));

                setTimeout(() => isReady({ loaded: true, options: true }), 1000);
            }
        } else {
            isReady({ loaded: true, options: true });
        }
    }, [WholeMarksLoaded, examSubjects, marks, students]);
    function PerformSummarySheet(students, year, ss, exam, practical) {
        const subStudent: [] = []
        students?.map((s, indx) => {
            const stud = s.student?.Summary?.student
            const studInfo = stud?.["class" + year]

            const id = Global.genSubId({ studentId: stud.id, classId: studInfo?.classId, examId: exam.name, year: year, subjectId: ss.id })

            const re = s.student[id]

            const lft = Global.isLeft(stud, year)
            const fal = (lft || Global.getResultStatus(re?.status) == "Fail") ? { borderBottomWidth: 1, color: "red" } : {}
            const able = (re?.theory == "Absent" || lft) ? { backgroundColor: "#DCDCDC" } : {}


            const printMarks = re == undefined ? (lft ? "Left" : "-") :
                Global.getDoubleZero(lft ? "Left" :
                    (practical ? (re?.theory == "Absent" ? "Absent" : re.practical) :
                        Global.getValue(re, "Ab")))

            subStudent.push({ roll: studInfo?.roll, value: printMarks, style1: able, style2: fal })
        })

        const nSt = subStudent.sort((a, b) => a?.roll - b?.roll)
        return nSt
    }


    return <View style={{ paddingBottom: 30 }}>

        {/* {data.classStudents?.length > 0 && examSubjects && <LoadMarksData examSubjects={examSubjects} allStudents={data.classStudents} year={data.year} std={data.std} exam={data.exam} />} */}
        {!exam?.final && <LoadMarksFromServer exam={exam} year={year} std={std} students={data.classStudents} />}
        <ScrollView horizontal>
            {!data.exam?.isInternal && <DChip disabled={!ready.options} onPress={() => {
                navigation.navigate("NewMarksheet", { list: data.classStudents, classId: std.id, year: year, examName: exam.name })
            }}>Print Marksheets (except left)</DChip>}
            {!data.exam?.isInternal && !data.exam?.final && <DChip disabled={!ready.options} onPress={() => {
                navigation.navigate("PrintSummarySheet", { classId: std.id, year: year, examName: exam.name })
            }}>Summary Sheet</DChip>}
            {!data.exam?.isInternal && !data.exam?.final && <DChip disabled={!ready.options} onPress={() => {
                navigation.navigate("PrintTarij", { classId: std.id, year: year, examName: exam.name })
            }}>તારીજ</DChip>}
            {!data.exam?.isInternal && !data.exam?.final && <DChip disabled={!ready.options} onPress={() => {
                // //console.log({ classId: std.id, year: year, examName: exam.name })
                navigation.navigate("PrintSubjectSheet", { classId: std.id, year: year, examName: exam.name })
            }}>Subject Sheet</DChip>}
            {data.exam?.isInternal && examSubjects && year && exam && std && <Segrigate navigation={navigation} year={year} std={std} exam={exam} subjects={examSubjects} students={data.classStudents} lockStatus={lockStatus} />}


            <SaveGeneratedReports std={std} exam={exam} year={year} reports={preparedSubjects.reports} disabled={!ready.options} current={current} lockStatus={lockStatus} marks={marks} navigation={navigation} />
            {!lockStatus?.locked && <Backup std={std} exam={exam} year={year} marks={marks} disabled={!ready.options} current={current} />}
        </ScrollView>
        {!lockStatus?.locked && <HelperText type='info' >Click on `Lock and Finalize` only after you see Rank of Student is being calculated.</HelperText>}

        <ScrollView horizontal>
            {(ready.loaded && !locked) ? <>
                {preparedSubjects?.subjects?.map((t, i) => {

                    return <SubjectsChip loading={false} stvm={stvm} onSelect={(t) => { setSelected({ ...t.subject }) }} t={t.subject} selected={selected} navigation={navigation} std={data.std} exam={data.exam} students={t.students} year={year} allSubjects={t.subjects} pending={t.pending} current={current} isFirst={i == 0} />
                })}</>
                : <View style={{ flexDirection: "row" }}>
                    <Text>{locked ? "" : "Wait, Loading Data..."}   {locked ? "" : marks?.length}
                    </Text>
                </View>}

        </ScrollView>
        {/* <Purge year={year} exam={exam} /> */}
        <MarksheetMessage current={current} year={year} std={std} exam={exam} lockStatus={lockStatus} />
        <FlatList
            data={data.classStudents}
            keyExtractor={(item) => item.id + ""}
            contentContainerStyle={{ backgroundColor: "transparent" }}

            keyboardShouldPersistTaps={'handled'}
            renderItem={({ item }) => {
                const cid = Global.StudentExamYearId({ student: item, exam: data.exam, std: data.std, year: data.year })
                const smarks = marks ? marks[cid] : undefined
                return <StudentChip cid={cid}
                    preparedMarks={smarks}
                    student={item} std={data.std} exam={data.exam} year={data.year} navigation={navigation} subjects={examSubjects} locked={locked} />
            }

            } />
    </View>
}
function honchi(v) {
    try {
        if (v == "") { return 0 }
        const v1 = parseInt(v)
        if (Number.isNaN(v1)) { return 0 }
        return v1
    } catch { }
    return 0
}

const LoadPresentDays = ({ cid }) => {
    const dispatch = useDispatch()

    React.useEffect(() => {
        const d = doc(getFirestore(), Global.PRESENTDAYS, cid);
        const sd = onSnapshot(d, { includeMetadataChanges: true }, (docc) => {
            const pdata = docc.data()
            // //console.log(pdata)
            dispatch(listsTask.actions.setPresentDays({ cid: cid, data: pdata }))
        })

        return () => {
            sd()
        }
    }, [])

    return <></>
}
const EnterPresentDays = ({ cid }) => {
    const base = useSelector(s => s.list.PresentDays[cid])
    const [val, setVal] = React.useState({ odays: 0, omess: "", days: 0, mess: "", daysWorking: false, messWorkng: false, daysSaved: false, messSaved: false })
    React.useEffect(() => {
        if (base) {
            setVal(p => ({ ...p, mess: base.mess, days: base.total, omess: base.mess, odays: base.total }))
        }
    }, [base])

    async function Save(what) {
        if (what == 1 && val.days !== val.odays) {
            setVal(p => ({ ...p, daysWorking: true }))
            const ref = doc(getFirestore(), Global.PRESENTDAYS, cid)
            await setDoc(ref, { id: cid, total: val.days }, { merge: true })
            setVal(p => ({ ...p, daysWorking: false, daysSaved: true }))
        } else {
            if (val.omess !== val.mess) {
                setVal(p => ({ ...p, messWorkng: true }))
                const ref = doc(getFirestore(), Global.PRESENTDAYS, cid)
                await setDoc(ref, { mess: val.mess }, { merge: true })
                setVal(p => ({ ...p, id: cid, messWorkng: false, messSaved: true }))
            }
        }
    }

    return <View>
        <View style={{ flexDirection: "row", alignItems: "center" }}>

            <View style={{ flexDirection: "row", alignItems: "center" }}>
                <TextInput style={{ backgroundColor: "transparent" }} onBlur={() => Save(1)} label='Total Days of Attandes' value={val.days ? val.days + "" : ""} onChangeText={(t) => {
                    const tt = parseInt(t)
                    if (!Number.isNaN(tt)) {
                        setVal(p => ({ ...p, days: tt }))
                    }
                }} />
                <ActivityIndicator animating={val.daysWorking} />
                {val.daysSaved && <IconButton iconColor='green' icon={"check"} />}
            </View>
            <View style={{ flexDirection: "row", alignItems: "center", flex: 1 }}>
                <TextInput style={{ backgroundColor: "transparent", flex: 1 }} onBlur={() => Save(2)} label='નોંધ' value={val.mess} onChangeText={(t) => { setVal(p => ({ ...p, mess: t })) }} />
                <ActivityIndicator animating={val.messWorkng} />
                {val.messSaved && <IconButton iconColor='green' icon={"check"} />}
            </View>
        </View>
    </View >
}

// const MergeBoth = ({ cid }) => {
//     const base = useSelector(s => s.list.PresentDays[cid])
//     const result = useSelector(s => s.list.FinalResult)
//     const dispatch = useDispatch()
//     React.useEffect(() => {
//             if (result && base) {
//                 result?.Marksheets?.map(r => {
//                     try {
//                         if (base[r.id]) {
//                             //console.log(r.id, base[r.id], base.total, base.mess)
//                             dispatch(listsTask.actions.updateDays({ id: r.id, days: base[r.id], total: base.total, mess: base.mess }))
//                         }
//                     } catch (e) {
//                         //console.log("errrr", e)
//                     }

//                 })

//             }
//         }, 2000)
//     }, [base, result])
//     return <></>
// }

const PrintMarksheet = ({ navigation, disabled, cid, year, current, std, exam, classStamp, subjects }) => {
    const present = useSelector(p => p.list.PresentDays[cid])
    const result = useSelector(p => p.list.FinalResult)
    const medical = useSelector(s => s.list.MedicalMarks[cid])
    const [wait, setWait] = React.useState(false)
    const dispatch = useDispatch()
    // //console.log("PrintMarksheet current", current)
    async function process() {
        const mer = []
        result.Marksheets.map(s => {
            const ss = { ...s }
            if (present[s.id]) {
                ss.present = present[s.id]
            }
            if (present.mess) {
                ss.mess = present.mess
            }
            if (present.total) {
                ss.totalDays = present.total
            }
            mer.push(ss)
        })
        return { data: mer, year: year, subjects: subjects, std: std, exam: exam }
    }
    async function save(d) {
        const e = await process()
        await SaveAndLock({ ...d, finalData: e })
        setWait(false)
    }
    return <View style={{ flexDirection: "row" }}>
        <ActivityIndicator animating={wait} />
        <DChip disabled={disabled} onPress={() => {
            setWait(true)
            process().then(e => {
                dispatch(listsTask.actions.setFinalMarksheet(e))
                setWait(false)
                navigation.navigate("FinalMarksheet")
            })
        }
        }>Final Marksheet</DChip>
        <DChip disabled={disabled} onPress={() => {
            setWait(true)
            process().then(e => {
                dispatch(listsTask.actions.setFinalMarksheet(e))
                setWait(false)
                navigation.navigate("NewFinalSummarySheet")
            })
        }}>Final Summary Sheet</DChip>

        <DChip style={{ marginLeft: 25 }} disabled={disabled} onPress={() => {
            setWait(true)
            // //console.log("Save and Lock PRPA", exam)
            save({ navigation, classStamp, current, exam, year, idata: false, reports: false, std })
        }}>Lock Result</DChip>
        <DChip disabled={disabled} onPress={() => {
            Unlock({ classStamp, navigation })
        }}>UnLock Result</DChip>

    </View>


}

const FinalAll = ({ current, allExams, navigation, year, std, exam, subjects, students, data, classId }) => {
    const finalData = useSelector(s => s.list.FinalData)
    const medical = useSelector(s => s.list.MedicalMarks[classId + year])
    const [sortby, setSortBy] = React.useState(0)
    const [expand, setExpand] = React.useState(0)
    const classStamp = exam.name + std.id + year
    const subjectByName = React.useMemo(() => {
        const lookup = {}
        subjects?.forEach(subject => {
            if (subject?.name) {
                lookup[subject.name] = subject
            }
        })
        return lookup
    }, [subjects])

    const [sortedData, setSortedData] = React.useState(finalData?.sdata1 || []);

    React.useEffect(() => {
        setSortedData(finalData?.sdata1 || []);
    }, [finalData]);

    function reCalc() {
        const allMarksheets = []
        const allSheet = []
        data?.classStudents?.map(s => {
            // //console.log("SS", year, s)
            const mark = {}
            mark.name = s.name
            mark.id = s.id
            mark.uid = s.uid
            mark.roll = s["class" + year]?.roll
            mark.gr = s["class" + year]?.gr
            if (s["class" + year]?.left) {
                mark.left = s["class" + year]?.left
            }
            //later take care of practical and grades
            let totalMarks = 0
            let totalGained = 0
            let status = "Pass"

            finalData.map(e => {
                if (e) {
                    // //console.log("INN", s.name, s.id, e)
                    if (e.isInternal) {
                        const eno = "4"
                        const im = {}
                        e.InternalReport.map(i => {
                            const got = i.students.find(is => is.id == s.id)
                            // //console.log(s.name, i.name, got, i)
                            im[i.name] = {}
                            if (got) {
                                im[i.name].internal = got.internal
                                totalGained = totalGained + got.internal
                                totalMarks = totalMarks + got.total
                            }
                            im[i.name].subjectId = i.id
                            im[i.name].subjectName = i.name
                        })
                        mark[eno] = im
                    } else {
                        // //console.log(s.name, e.Marksheets[s.id])
                        const im = {}
                        const eno = e.examNo + ""
                        if (e.Marksheets[s.id]) {
                            im.status = e.Marksheets[s.id].status
                            im.totalGained = e.Marksheets[s.id].totalGained
                            im.pc = e.Marksheets[s.id].pc
                            im.totalMarks = e.Marksheets[s.id].totalMarks
                            // //console.log("Trinch", JSON.parse(JSON.stringify(e.Marksheets[s.id])), e.Marksheets[s.id].totalMarks)
                            totalMarks = totalMarks + im.totalMarks
                            totalGained = totalGained + im.totalGained
                            // //console.log(im, e.Marksheets[s.id])
                            e.Marksheets[s.id].marks.map(i => {
                                im[i.name] = { ...i }
                                if (e.examNo == 3) {
                                    const p = i.practical
                                    const ipra = !(p == "" || p == undefined)
                                    if (ipra) {
                                        im[i.name].isPractical = true
                                        im[i.name].practical = p
                                    }
                                }
                            })
                            if (totalGained < 66 && status == "Pass") {
                                status = "Fail"
                            }
                        }
                        mark[eno] = im
                    }
                }
            })
            // check for final status
            // //console.log(s.name, "mark", JSON.parse(JSON.stringify(mark)))
            const final = {}
            let subjectCount = 0
            if (mark["3"]) {
                Object.keys(mark["3"]).forEach(function (key) {
                    if (typeof mark["3"][key] == "object") {
                        // //console.log(s.name, key, mark["3"][key])
                        final[key] = {}
                        const e1 = mark["1"][key]?.theory ? mark["1"][key]?.theory : 0
                        const e2 = mark["2"][key]?.theory ? mark["2"][key]?.theory : 0
                        const e3 = mark["3"][key]?.theory ? mark["3"][key]?.theory : 0
                        // //console.log("MMerge", key, s.id + "e1" + key, medical[s.id + "e1" + key], medical[s.id + "e1" + key] > -1, medical)
                        try {
                            if (medical[s.id + "e1" + key] > -1) {
                                //                            //console.log("MMerge in")
                                final[key]["m1"] = medical[s.id + "e1" + key]
                                final.medical = true
                            }
                        } catch { }
                        try {
                            // //console.log("INNNNT", s.name, medical[s.id + "e2" + key])
                            // //console.log("OFF", medical)
                            if (medical[s.id + "e2" + key] > -1) {
                                final[key]["m2"] = medical[s.id + "e2" + key]
                                final.medical = true
                            }
                        } catch { }
                        try {
                            if (medical[s.id + "e3" + key] > -1) {
                                final[key]["m3"] = medical[s.id + "e3" + key]
                                final.medical = true
                            }
                        } catch { }

                        if (mark["1"][key]?.theory == "Absent") {
                            if (!(final[key]["m1"] > -1)) {
                                final[key]["e1A"] = true
                            }
                        }
                        if (mark["2"][key]?.theory == "Absent") {
                            if (!(final[key]["m2"] > -1)) {
                                final[key]["e2A"] = true
                            }
                        }
                        if (mark["3"][key]?.theory == "Absent") {
                            if (!(final[key]["m3"] > -1)) {
                                final[key]["e3A"] = true
                            }
                        }
                        const sg = subjectByName[key]
                        let isPractical = false
                        let practicalMarks = 0
                        if (sg) {
                            final[key]["order"] = sg.order
                            final[key]["totalFinalMarks"] = sg.totalMarks
                            final[key]["isPractical"] = sg.practical ? true : false
                            if (sg.practical) {
                                isPractical = true
                                practicalMarks = mark["3"][key]["practical"]
                            }
                        } else {

                            if (mark["3"][key]?.practical) {
                                final[key]["isPractical"] = true
                                isPractical = true
                                practicalMarks = mark["3"][key].practical
                            }
                        }
                        // //console.log(s.name, key, mark["4"][key]?.internal)
                        const e4 = mark["4"][key]?.internal


                        final[key]["e1"] = e1
                        final[key]["e2"] = e2
                        final[key]["e3"] = e3
                        let mm1 = 0
                        try {
                            if (final[key]["m1"]) {
                                mm1 = final[key]["m1"]
                            }
                        } catch { }
                        let mm2 = 0
                        try {
                            if (final[key]["m2"]) {
                                mm2 = final[key]["m2"]
                            }
                        } catch { } let mm3 = 0
                        try {
                            if (final[key]["m3"]) {
                                mm3 = final[key]["m3"]
                            }
                        } catch { }

                        final[key]["practical"] = isPractical ? practicalMarks : 0

                        final[key].theory = honchi(e1) + honchi(e2) + honchi(e3) + honchi(mm1) + honchi(mm2) + honchi(mm3)
                        // //console.log(s.name, key, final[key]["m1"], final[key]["m2"], final[key]["m3"], final[key].theory, final)
                        final[key].internal = (e4 ? e4 : 0)
                        final[key].total = final[key].theory + final[key].internal + final[key].practical
                        // if (isPractical) {
                        //     //console.log("GRAND", s.name, key, final[key].theory, final[key].internal, final[key].practical, final)

                        // }
                        if (!isPractical) {
                            subjectCount++
                        }
                        final[key].totalMarks = isPractical ? 100 : 200
                        final[key].marks = Math.round((final[key].total * 100) / final[key].totalMarks)
                        final[key].status = Global.getPassFail(final[key].marks, 100)
                        // //console.log(s.name, key, final[key].theory, final[key].internal, final[key].practical, final[key].marks, final[key].totalMarks)
                    }
                })
            }

            let totalMarksInFinal = 0

            let onlyFinalTotal = 0
            let tempStatus = "Pass"
            // let theorySubjectsCount = subjects.filter(f => !f.practical)?.length
            Object.keys(final).forEach(function (key) {
                if (typeof final[key] == "object") {
                    totalMarksInFinal = totalMarksInFinal + final[key].marks
                    if (!final[key]["isPractical"]) {
                        onlyFinalTotal = onlyFinalTotal + final[key].marks
                    }
                    if (final[key].status !== "Pass") {
                        tempStatus = "Fail"
                    }
                }
            })

            // //console.log(s.name, subjectCount, totalMarksInFinal, onlyFinalTotal)

            final.totalGained = totalMarksInFinal
            final.finalTotal = onlyFinalTotal
            final.finalFrom = subjectCount * 100
            final.status = tempStatus
            final.std = std?.name
            final.div = std?.div

            final.pc = parseFloat((final.finalTotal / subjectCount).toFixed(2))
            const tpc = Math.round(final.pc)
            const tegl = tpc > 33 ? Math.round(tpc - 33) : 0
            let kripaAvailable = 10
            let siddhiAvailable = tegl > 15 ? 15 : tegl
            let sgiven = 0
            let kgiven = 0

            let doneSOmething = false
            if (tempStatus == "Fail") {
                Object.keys(final).forEach(function (key) {
                    if (final[key].status == "Fail") {
                        let needed = 33 - final[key].marks
                        // //console.log(s.name, key, tpc, needed, final[key].marks)

                        if (needed <= (siddhiAvailable + kripaAvailable)) {
                            const deductSiddthi = (needed >= siddhiAvailable) ? siddhiAvailable : needed
                            // //console.log("deductSiddthi", deductSiddthi)

                            siddhiAvailable = siddhiAvailable - deductSiddthi
                            // //console.log("siddhiAvailable", siddhiAvailable)
                            needed = needed - deductSiddthi
                            // //console.log("needed", needed)
                            final[key].sgiven = deductSiddthi
                            sgiven = sgiven + deductSiddthi
                            // //console.log(sgiven, deductSiddthi)
                            // //console.log("kripa avail", kripaAvailable, needed)

                            if (needed > 0) {
                                kripaAvailable = kripaAvailable - needed
                                final[key].kgiven = needed
                                kgiven = kgiven + needed
                                needed = 0
                            }
                            // //console.log("Sk final", needed, kripaAvailable, siddhiAvailable)
                            if (needed == 0) {
                                // //console.log("status change", "PASS")
                                final[key].status = "Pass"
                                doneSOmething = true
                            } else {
                                // //console.log("Logical Error")
                            }
                        }

                    }
                })
            }
            if (doneSOmething) {
                // //console.log("DONE some")
                let tstatus = "Pass"
                Object.keys(final).forEach(function (key) {
                    if (typeof final[key] == "object") {
                        if (final[key].status !== "Pass") {
                            // //console.log(key, final[key].status)
                            tstatus = "Fail"
                        }
                    }

                })
                final.kripaGiven = kgiven
                final.siddhiGiven = sgiven
                final.status = tstatus
                // //console.log("DONE some", tstatus)

                if (tstatus == "Fail") {
                    final.pc = ""
                    final.kripaGiven = 0
                    final.siddhiGiven = 0
                }
            }
            const markWithFinal = { ...mark, final }
            // //console.log(s.name, final)
            allMarksheets.push(markWithFinal)


        })

        // now ranking
        const sdata = allMarksheets?.sort((a, b) => {
            const aScore = (a.final?.finalTotal || 0) + (a.final?.siddhiGiven || 0);
            const bScore = (b.final?.finalTotal || 0) + (b.final?.siddhiGiven || 0);
            return bScore - aScore; // descending order
        });

        let prevScore = null;   // last score seen
        let rank = 0;           // current rank to assign
        let count = 0;          // number of eligible students processed

        sdata?.forEach(o => {
            try {
                if (!o.final.kripaGiven && !o.final.medical) {
                    const score = (o.final.finalTotal || 0) + (o.final.siddhiGiven || 0);

                    if (o.final.status === "Pass" && o.left !== true) {
                        count++; // increment number of eligible students

                        if (prevScore === score) {
                            // same score → same rank
                            o.rank = rank;
                        } else {
                            // new lower score → rank = count
                            rank = count;
                            o.rank = rank;
                            prevScore = score;
                        }
                    } else {
                        o.rank = 0; // not eligible
                    }
                } else {
                    o.rank = 0; // excluded due to kripa or medical
                }
            } catch (e) {
                console.error("Ranking error:", e);
            }
        });
        const sdata1 = sortby == 0 ? sdata?.sort((a, b) => a.roll - b.roll) : sdata?.sort((a, b) => {
            // Ensure rank exists, fallback to 9999 so unranked go last
            const rankA = a.rank || 9999;
            const rankB = b.rank || 9999;
            return rankA - rankB; // ascending rank
        })

        sdata1.map(m => {
            if ((m.rank == 1) || (m.rank == 2) || (m.rank == 3)) {
                m.note = "Congratulations"
            }
        })
        sdata1.map(st => {
            const sheet = { ...st }
            delete sheet["1"]
            delete sheet["2"]
            delete sheet["3"]
            delete sheet["4"]
            const subs = []
            // //console.log(st)
            const obj = {}
            Object.keys(st.final).forEach(function (key) {
                if (typeof st.final[key] == "object") {
                    const ss = st.final[key]
                    ss.name = key
                    subs.push(ss)

                } else {
                    obj[key] = st.final[key]
                }
            })
            const a2 = subs.sort((a, b) => a.order - b.order)
            sheet.subjects = a2
            delete sheet.final
            const sheet1 = { ...sheet, ...obj }
            allSheet.push(sheet1)
        })

        return { sdata: sdata, sdata1: sdata1, sheet: allSheet }
    }

    const dispatch = useDispatch()
    const finalReport = React.useMemo(() => reCalc(), [finalData, medical, data?.classStudents, subjectByName, std, year, sortby])

    React.useEffect(() => {
        dispatch(listsTask.actions.setFianlReport({ data: finalReport.sdata, subjects: subjects, std: std, year: year, Marksheets: finalReport.sheet }))
    }, [dispatch, finalReport, subjects, std, year])


    const [wait, setWait] = React.useState(true)
    const allIds = React.useMemo(() => {
        const ids: Array<string> = []
        allExams.forEach(e => {
            ids.push(e + std.id + year)
        })
        return ids
    }, [allExams, std.id, year])

    React.useEffect(() => {

        const ref = collection(getFirestore(), Global.RESULTREPORT)
        const q = query(ref, where("id", "in", allIds))
        const s = onSnapshot(q, { includeMetadataChanges: true }, (docc) => {
            let tklist: [] = []
            docc.docChanges().forEach((change) => {
                tklist.push(change.doc.data())
            })
            // //console.log("tklist final", tklist)
            dispatch(listsTask.actions.setFinalData({ data: tklist }))
            setWait(false)
        })


        const d = doc(getFirestore(), Global.PRESENTDAYS, classId + year);
        const sd = onSnapshot(d, { includeMetadataChanges: true }, (docc) => {
            const pdata = docc.data()
            dispatch(listsTask.actions.setPresentDays({ cid: classId + year, data: pdata }))
        })

        return () => {
            s()
            sd()
        }
    }, [allIds, classId, dispatch, std.id, year])

    return <View>
        <LoadPresentDays cid={classId + year} />
        <EnterPresentDays cid={classId + year} />
        <ScrollView horizontal>
            <View style={{ flexDirection: "row", padding: 12, alignItems: "center" }}>
                <ActivityIndicator animating={wait} />
                <PrintMarksheet current={current} std={std} classStamp={classStamp} navigation={navigation} disabled={!finalData} exam={exam}
                    subjects={subjects} cid={classId + year} year={year} />
                <Button
                    onPress={() => {
                        if (sortby == 0) {
                            setSortBy(1)
                        } else {
                            setSortBy(0)
                        }
                    }}
                >{sortby == 0 ? "Sort by Rank" : "Sort by Roll"}</Button>
                <Button
                    onPress={() => {
                        if (expand == 0) {
                            setExpand(1)
                        } else {
                            setExpand(0)
                        }
                    }}
                >{expand == 0 ? "Expand" : "Collapse"}</Button>
            </View>
        </ScrollView>
        <FlatList
            data={finalReport.sdata1}
            keyExtractor={(item) => item.id + ""}
            renderItem={({ item }) => {
                return <FinalStudentRow expand={expand} subjects={subjects} d={item} cid={classId + year} year={year} update={() => {

                }} />
            }}
        />

    </View>
}
async function SaveMarksLog({ current, data, merge = false }) {
    const today = new Date();
    let day = today.getDate();
    let month = today.getMonth() + 1;
    let year = today.getFullYear();

    const db = getFirestore()
    const ref = doc(collection(db, Global.MARKSLOG))

    const d = {
        ...data,
        id: ref.id,
        savedBy: { id: current?.current?.id, name: current?.current?.name, time: `Backup by ${current?.current?.name} on ${day}/${month}/${year}` },
        stamp: new Date().getTime(),
    }


    const e = await setDoc(ref, d).then(e => {
        return 1
    }).catch(e => {
        console.log(findUndefinedPaths(d))
        return -1
    })
    return e
}

const Backup = ({ marks, current, exam, std, year, disabled }) => {
    const [wait, setWait] = React.useState(false)
    const classStamp = exam.name + std.id + year
    const idata = useSelector(s => s.list.InternalSummary[std?.id + year + exam.name])

    return <View style={{ flexDirection: "row" }}> <DChip disabled={disabled} onPress={() => {
        setWait(true)

        const classYearStamp = std.id + year

        const entry = {}
        entry.classStamp = classStamp
        entry.Marks = exam?.isInternal ? idata : marks
        entry.classYearStamp = classYearStamp
        entry.examNo = exam?.exam
        entry.isInternal = exam?.isInternal == undefined || exam?.isInternal == false ? false : true

        ////console.log("Backup Entry", entry, exam?.isInternal)
        SaveMarksLog({ current, data: entry }).then(e => {
            if (e == 1) {
                alert("Backup Taken Successfully")
            } else {
                alert("Error")
            }
            setWait(false)
        })
    }} >Backup Marks Entry data</DChip>
        <ActivityIndicator animating={wait} />
    </View >
}
const MarksheetMessage = ({ current, year, std, exam, lockStatus }) => {
    const classStamp = exam?.name + std?.id + year
    const mess = useSelector(s => s.list.ExamMessages[classStamp])
    const [edit, setEdit] = React.useState({ mode: 0, message: "" })
    const dispatch = useDispatch()
    React.useEffect(() => {
        const citiesRef = doc(getFirestore(), Global.EXAM_MESSAGE, classStamp);
        const l = onSnapshot(citiesRef, (doc) => {
            const data = doc.data();
            dispatch(listsTask.actions.setMessage({ classStamp: classStamp, data: data }))
        })
        return () => {
            l()
        }
    }, [])
    React.useEffect(() => {
        // //console.log("lockStatus", mess)
        setEdit(p => ({ ...p, message: mess?.message }))
    }, [mess])


    function save() {
        const classStamp = exam.name + std.id + year
        const r = doc(getFirestore(), Global.EXAM_MESSAGE, classStamp)
        const data = {
            id: r.id,
            message: edit.message,
            messageBy: current?.current?.name ? current?.current?.name : ""
        }
        setDoc(r, data, { merge: true }).then(e => {
            setEdit(p => ({ ...p, mode: 0 }))
        })
    }
    return <View style={{ paddingBottom: 12 }}>
        <TouchableOpacity disabled={lockStatus?.locked} style={{ paddingTop: 12 }} onPress={() => { setEdit(p => ({ ...p, mode: edit.mode == 0 ? 1 : 0 })) }}>
            <View style={{ flexDirection: "row", alignItems: "center" }}>
                <Text>{!lockStatus?.locked ? <MaterialCommunityIcons name="pen" /> : <></>} Marksheet Note </Text>
                {edit.mode == 0 && <Text> : {edit.message}</Text>}
            </View>
        </TouchableOpacity>
        {
            edit.mode == 1 && <View style={{ flexDirection: "row" }}>
                <TextInput style={{ flex: 1 }} value={edit.message} onChangeText={(t) => {
                    setEdit(p => ({ ...p, message: t }))
                }} placeholder='Write note here...' />
                <Button mode="contained" onPress={save}>Save</Button>
            </View>
        }
    </View>
}

// STUDENT MARKS TO BE TAKEN FROM SERVER, DUMPTED, RETRIVED, PREPARED SUMMARY CHIP, POST SUMMARY (?)
const StudentChip = React.memo(({ cid = "", preparedMarks, student, exam, year, subjects, navigation, std, dark, locked }) => {
    // taking data from server, sent to listTask and taken in preparedMarks, than reclaculate rank, send to listTask taken into Marks Summary, and taken into setMarks
    // both are not common as onsnapshot may give diff lenght data, all needs to merged and placed at one place, so list task is needed, and than to retrived in prepared marks,
    // const marks = useSelector(s => s.list.Marks[cid])

    // const [marks, setMarks] = React.useState()
    const dispatch = useDispatch()


    // TAKING SUBJECT MARKS DATA FROM SERVER, PASSED TO DUMP as OBJECT
    // cannot keep this code to OnlySingleStudent as, otherwise with every first visit data will be emptyF
    // React.useEffect(() => {
    //     let s
    //     if (student?.id && !exam?.final) {
    //         const db = getFirestore()
    //         const citiesRef = collection(db, Global.MARKS);
    //         let me = {}
    //         const sid = student.id + std.id + exam.name + year
    //         const q = query(citiesRef, where("eid", "==", sid));
    //         s = onSnapshot(q, { includeMetadataChanges: true },
    //             (docc) => {
    //                 docc.docChanges().forEach((change) => {
    //                     const d = change.doc.data()
    //                     if (change.type === "removed") {
    //                         if (d.id) {
    //                             delete me[d.id]
    //                         }
    //                     } else {
    //                         if (d?.id) {
    //                             me[d.id] = d
    //                         }
    //                     }
    //                 })
    //                 const classId = student["class" + year]?.classId
    //                 const examClass = exam.forClass.find(e => e.classId == classId)
    //                 //                    //console.log(student.name, me)
    //                 dispatch(listsTask.actions.updateMarks({ type: Global.MARKS, examName: exam.name, data: me, cid: cid, classId: classId, student: student, examClass: examClass, year: year }))
    //             })
    //     }

    //     return () => {
    //         if (s) { s() }
    //     }
    // }, [student])


    // React.useEffect(() => {
    //     setMarks(preparedMarks)
    // }, [preparedMarks])


    const S = preparedMarks?.Summary
    const RESULT = Global.getResultStatus(S?.status)
    // //console.log("StudentChip", student.name, preparedMarks, S)
    return <View style={{ marginBottom: 5, marginTop: 2 }}>
        <Pressable onPress={() => {
            if (!exam?.isInternal) {
                navigation.navigate("NewMarksheet", { id: student.id, classId: std.id, year: year, examName: exam.name })
            }
        }}>
            <StudentPlainRow dark={dark} info={student} withGr={false} currentYear={year} nodivider={true} />

        </Pressable>
        {
            !student["class" + year]?.left && <>
                {
                    !exam?.final ? <ScrollView horizontal style={{ paddingLeft: 30, minHeight: 25, }}>
                        {preparedMarks == undefined ?
                            <View>
                                {locked ?
                                    <PreRecordedStatus id={student.id} classId={std.id} year={year} examName={exam.name} />
                                    : <Text>{"Loading..."}</Text>}
                            </View>
                            : <View>

                                <View>
                                    <View style={{ flexDirection: "row" }}>
                                        <Text style={{ color: RESULT == "Pass" ? "green" : RESULT == "Fail" ? "red" : undefined }}>{RESULT}   </Text>
                                        {(!exam?.isInternal) && RESULT == "Pass" && S?.rank && <Badge style={{ backgroundColor: "dodgerblue", color: "white" }}>{S?.rank ? "Rank " + S?.rank : ""} </Badge>}
                                    </View>
                                    {S?.pending.length ? <Badge style={{ paddingLeft: 5, paddingRight: 4, backgroundColor: "orange", color: "black" }} size={25}>Pending : {S?.pending.length == S?.subjectCount ? "All" : S?.pending.length}</Badge> : <></>}

                                    {!exam?.isInternal && S?.status == "Absent" &&
                                        <Badge style={{ paddingLeft: 5, paddingRight: 5, backgroundColor: "gray", color: "white" }}>Absent : {S?.absent?.map((e, i) => (i == 0 ? "" : ",") + e)}</Badge>}
                                    {!exam?.isInternal && S?.status == "Fail" &&
                                        <Badge style={{ paddingLeft: 5, paddingRight: 5, backgroundColor: "red", color: "white" }}>Fail : {S?.map((e, i) => (i == 0 ? "" : ",") + e)}</Badge>
                                    }

                                    {!exam?.isInternal && S?.status == "Pass" &&
                                        <View style={{ flexDirection: "row" }}>
                                            {/* <Badge style={{ backgroundColor: "red" }}>{data?.marksObject?.pass?.map((e, i) => (i == 0 ? "" : ",") + e)}</Badge> */}
                                            <Text style={{ color: "green" }}>  {S?.pc > -1 ? "Pass (" + S?.pc + "%, માર્કસ=" + S?.totalGained + ") " : ""}</Text>
                                        </View>
                                    }
                                </View>
                            </View>}
                    </ScrollView> : <View style={{ paddingLeft: 30 }}>
                        <View style={{ flexDirection: "row" }}>

                            <Text variant={"titleLarge"} style={{ color: S?.status == "Pass" ? "green" : "red" }}>{S?.status} {S?.pc ? S?.pc + "%" : ""}</Text>
                            <Text variant={"titleLarge"} style={{ color: "blue" }}> {S?.rank ? "Rank " + S?.rank : ""} </Text>
                            <Text style={{ color: dark ? "black" : undefined }}> {(S?.selfMarks)}/{S?.subjectCount}</Text>
                            <View style={{ alignItems: "center", justifyContent: "center", flexDirection: "row" }}>
                                {S?.failed.length > 0 && S?.failed.length < 3 && <IconButton icon={"lightbulb-on"} iconColor='white' />}
                                {S?.failed.length > 0 && S?.failed.length < 3 && <Text variant={"titleLarge"} style={{ backgroundColor: "yellow", color: dark ? "black" : undefined }}>{S?.failed.length ? " " + S?.failed.length + " " : ""}</Text>}
                            </View>
                        </View>
                    </View>
                }
            </>
        }
        <Divider leftInset />
    </View >
})

const PreRecordedStatus = ({ id, classId, year, examName }) => {
    const marks = useSelector(s => s.list.Marksheets[classId + year + examName])
    const [data, setData] = React.useState()
    React.useEffect(() => {
        try {
            const m = marks[id]
            setData(m)
        } catch (e) { }

    }, [marks])
    const PASS = Global.getResultStatus(data?.status) == "Pass"

    return <View style={{ flexDirection: "row", alignItems: "center" }}>
        {data && <Text variant="titleLarge" style={{ color: PASS ? "green" : "red", marginLeft: 12 }}>{data?.status}  {PASS ? data?.pc + "%" : ""}  </Text>}
        {data && PASS && <View style={{ flexDirection: "row", alignItems: "center", marginLeft: 20 }}>
            <Text>Rank </Text>
            <Badge style={{ backgroundColor: "orange", color: "black" }} size={30}>{data?.rank + ""}</Badge>
        </View>
        }

    </View>

}

const SubjectsChip = React.memo(({ t, onSelect, selected, navigation, std, exam, students, year, allSubjects, pending, stvm, current, isFirst, loading }) => {
    const dispatch = useDispatch()
    return <View style={{ flexDirection: "row", justifyContent: "center", alignItems: "center" }}>
        {
            isFirst && pending == -100 && <ActivityIndicator animating />
        }
        <View style={{ padding: 7 }}>
            <DChip disabled={pending == -100} selected={t.id == selected?.id} onPress={() => {
                // //console.log("SSS", t)
                onSelect({ ...t })
                dispatch(listsTask.actions.emptyList({ type: "ExamDump" }))
                navigation.navigate("MarksEntry", { exam: exam, subject: t, year: year, std: std, allExams: undefined, students: students, examSubjects: allSubjects, fresh: () => { } })
            }} >{t.name}</DChip>
        </View>
        <View style={{ position: "absolute", top: 0, right: 0 }}>
            {pending == -100 ? <MaterialCommunityIcons name="timer-outline" /> :
                <Badge size={25}
                    style={{
                        backgroundColor: pending == 0 ? "green" : "orange",
                        color: pending == 0 ? "white" : "black"
                    }}>
                    {pending ? pending : ""}</Badge>}
        </View>
    </View >
})


const Segrigate = ({ navigation, year, exam, std, subjects, students, lockStatus }) => {
    const [wait, setWait] = React.useState(false)

    const data = useSelector(s => s.list.InternalData[std?.id + year + exam.name])
    const dispatch = useDispatch()

    React.useEffect(() => {
        setWait(true)
        const db = getFirestore()
        let s
        // //console.log("classStamp", lockStatus)
        if (lockStatus?.locked == true) {
            // exam.name + std.id + year
            const classStamp = Global.getClassStamp({ examname: exam.name, stdid: std?.id, year: year, div: std?.div })
            // //console.log("classStamp", classStamp)
            const ref = doc(db, Global.RESULTREPORT, classStamp)
            // let q = query(, where("c", "==", exam.name), where("stdId", "==", std.id), where("year", "==", year));
            s = onSnapshot(ref, { includeMetadataChanges: true },
                (docc) => {
                    const data = docc.data()
                    // //console.log("classStamp", data)
                    if (data?.InternalReport) {
                        // //console.log("classStamp", "in")
                        dispatch(listsTask.actions.setInternalSummary({ examName: exam.name, classId: std.id, list: data?.InternalReport, year: year }))
                    }
                    setWait(false)
                })

        } else {
            const citiesRef = collection(db, Global.MARKS);
            let q = query(citiesRef, where("examId", "==", exam.name), where("stdId", "==", std.id), where("year", "==", year));
            let firstLoad = true
            s = onSnapshot(q, { includeMetadataChanges: true },
                (docc) => {
                    let tklist: [] = []
                    let del = []

                    docc.docChanges().forEach((change) => {
                        const d = change.doc.data()
                        if (change.type === "removed") {
                            if (d.id) {
                                //                                delete me[d.id] // ok we may need it to remove from redux
                            }
                        } else {
                            if (d?.id) {
                                tklist.push(d)
                            }
                        }
                    });

                    dispatch(listsTask.actions.setInternalData({ examName: exam.name, classId: std.id, internal: tklist, year: year }))
                    if (firstLoad && !docc.metadata.fromCache) {
                        dispatch(listsTask.actions.setDataReceived({ received: true }));
                        firstLoad = false;
                    }
                    setWait(false)
                })
        }
        return () => {
            if (typeof s == "function") {
                s()
            }
        }
    }, [])

    React.useEffect(() => {
        const list = []
        // //console.log("processed sub", data)
        if (data) {
            // //console.log("processed has data")
            subjects?.map(sub => {
                // //console.log("processed has subject", sub.name)
                const pList = []
                let inverse = false
                data.map(d => {
                    const dd = { ...d }
                    const ii = d.internal
                    let e1 = 0
                    let e2 = 0
                    let e3 = 0
                    let e4 = 0
                    if (ii == 15) {
                        e1 = 4
                        e2 = inverse ? 3 : 4
                        e3 = inverse ? 4 : 3
                        e4 = 4
                    } else if (ii == 14) {
                        e1 = 4
                        e2 = inverse ? 4 : 3
                        e3 = inverse ? 4 : 3
                        e4 = 3
                    } else if (ii == 13) {
                        e1 = 3
                        e2 = inverse ? 4 : 3
                        e3 = inverse ? 4 : 3
                        e4 = 3
                    } else if (ii == 12) {
                        e1 = 3
                        e2 = inverse ? 4 : 3
                        e3 = inverse ? 4 : 4
                        e4 = 2
                    } else if (ii == 11) {
                        e1 = 3
                        e2 = inverse ? 2 : 3
                        e3 = inverse ? 3 : 2
                        e4 = 3
                    } else if (ii == 10) {
                        e1 = 3
                        e2 = inverse ? 2 : 3
                        e3 = inverse ? 3 : 2
                        e4 = 2
                    } else if (ii == 1) {
                        e1 = 0
                        e2 = 1
                        e3 = 0
                        e4 = 0
                    } else if (ii == 2) {
                        e1 = 0
                        e2 = 1
                        e3 = 1
                        e4 = 0
                    } else if (ii == 3) {
                        e1 = 1
                        e2 = 1
                        e3 = 0
                        e4 = 1
                    } else if (ii == 4) {
                        e1 = 1
                        e2 = 1
                        e3 = 1
                        e4 = 1
                    } else if (ii < 10 && ii > 4) {
                        const r = Math.round(9 / 4)
                        e1 = r
                        e2 = r
                        e3 = r
                        e4 = 9 - (r * 3)

                    } else if (ii == 16) {
                        e1 = 4
                        e2 = inverse ? 5 : 3
                        e3 = inverse ? 3 : 5
                        e4 = 4

                    } else if (ii == 17) {
                        e1 = 4
                        e2 = inverse ? 5 : 4
                        e3 = inverse ? 4 : 5
                        e4 = 4

                    } else if (ii == 18) {
                        e1 = 5
                        e2 = inverse ? 5 : 4
                        e3 = inverse ? 4 : 5
                        e4 = 4

                    } else if (ii == 19) {
                        e1 = 5
                        e2 = 5
                        e3 = 4
                        e4 = 5

                    } else if (ii == 20) {
                        e1 = 5
                        e2 = 5
                        e3 = 5
                        e4 = 5
                    }
                    inverse = !inverse
                    dd.i1 = e1
                    dd.i2 = e2
                    dd.i3 = e3
                    dd.i4 = e4
                    pList.push(dd)
                })
                // //console.log("isumm data", data)
                const slist = pList.filter(s => s.subjectId == sub.id)
                // //console.log("isumm sub", slist)
                const nList = []
                students.map(m => {
                    const md = { id: m.id, name: m.name }
                    if (m["class" + year]?.roll) {
                        md.roll = m["class" + year]?.roll
                        if (m["class" + year]?.left) {
                            md.left = m["class" + year]?.left
                        }
                    }

                    const got = slist.find(i => i.studentId == m.id)
                    md.theory = got?.theory ? got.theory : ''

                    if (got) {
                        md.internal = got.internal
                        md.i1 = got.i1
                        md.i2 = got.i2
                        md.i3 = got.i3
                        md.i4 = got.i4
                    }
                    // if (md.roll == 48) {
                    //     //console.log(md.name, md, got.slist)
                    // }
                    nList.push(md)
                })
                list.push({
                    id: sub.id,
                    name: sub.name,
                    totalMarks: sub?.totalMarks,
                    year: year,
                    students: nList
                })
                // //console.log("isumm", list)
                dispatch(listsTask.actions.setInternalSummary({ examName: exam.name, classId: std.id, list: list, year: year }))
            })
        }

    }, [data, subjects])


    return <View style={{ flexDirection: "row", alignItems: "center" }}><ActivityIndicator animating={wait} /><DChip disabled={wait} onPress={() => {
        navigation.navigate("InternalSummary2", { examName: exam.name, std: std, year: year })
    }}>Internal Report</DChip></View>
}


function findUndefinedValues(obj, path = "") {
    let undefinedFields = [];

    if (obj && typeof obj === "object") {
        for (const [key, value] of Object.entries(obj)) {
            const newPath = path ? `${path}.${key}` : key;

            if (value === undefined) {
                undefinedFields.push(newPath);
            } else if (Array.isArray(value)) {
                value.forEach((item, index) => {
                    if (item === undefined) {
                        undefinedFields.push(`${newPath}[${index}]`);
                    } else {
                        undefinedFields.push(...findUndefinedValues(item, `${newPath}[${index}]`));
                    }
                });
            } else if (typeof value === "object" && value !== null) {
                undefinedFields.push(...findUndefinedValues(value, newPath));
            }
        }
    }

    return undefinedFields;
}

const AbsentMarks = ({ what, subject, student, cid, update }) => {
    const m = useSelector(s => s.list.MedicalMarks[cid])
    const [me, setMe] = React.useState("")
    const [para, setpara] = React.useState()
    const [open, setOpen] = React.useState("")
    const [medMarks, setMedMarks] = React.useState(0)
    const [working, setWorking] = React.useState(false)
    React.useEffect(() => {
        if (student?.id && cid) {
            setpara({ id: student.id, student: student, cid: cid, subject: subject })
        }
    }, [student, cid, subject])

    React.useEffect(() => {
        if (m && para) {
            if (para?.id && para?.subject) {
                const n = m[para?.id + what + para?.subject.name]
                if (me !== n) {
                    setMe(n)
                }
            }
        }
    }, [m, para])

    async function Save() {
        setWorking(true)
        const ref = doc(getFirestore(), Global.MEDICALMARKS, cid)
        if (para?.id && para?.cid && para?.subject) {
            const mn = para.id + what + para?.subject.name
            await setDoc(ref, { id: cid, [mn]: medMarks }, { merge: true })
            setTimeout(() => {
                setWorking(false)
                setOpen("")
            }, 3000)
            update()

        } else {
            alert("Parameter missing, cannot save")
        }
    }

    return <View>
        <Pressable onPress={() => { setOpen(what) }}>
            <View style={{ flexDirection: "row", alignItems: "center" }}>
                <Text style={{ color: "black" }}>{me ? me : "Absent"}</Text>
                {me && <Text style={{ fontSize: 9, backgroundColor: "orange", color: "black" }}>{" Medical "}</Text>}
            </View>
        </Pressable>
        <DModal
            style={{ flex: 1, alignSelf: "stretch", backgroundColor: "#637b7b" }}
            isVisible={open !== ""}
            onDismiss={() => setOpen("")}>
            <View>
                <IconButton style={{ alignSelf: "center" }} size={40} iconColor='white' icon={"hospital-box-outline"} />
                <Text variant="titleLarge" style={{ fontWeight: "bold", flex: 1, color: "white" }}>મેડિકલ સર્ટિફિકેટ આધારિત માર્ક્સની ફાળવણી</Text>
                <View style={{ marginLeft: 30, marginTop: 10, marginBottom: 10 }}>
                    <Text variant="titleLarge" style={{ flex: 1, color: "white" }}>પરીક્ષા  :{open == "e1" ? "પ્રથમ પરિક્ષા " : ""}{open == "e2" ? "દ્વિતીય પરીક્ષા " : ""}{open == "e3" ? "વાર્ષિક પરીક્ષા" : ""}</Text>
                    <Text variant="titleLarge" style={{ flex: 1, color: "white" }}>વિષય  :{subject.name} </Text>
                    <Text variant="titleLarge" style={{ flex: 1, color: "white" }}>વિદ્યાર્થી :{student?.name}</Text>
                </View>
                <View style={{ justifyContent: "center", alignItems: "center", flex: 1, flexDirection: "row" }}>
                    <TextInput autoFocus selectTextOnFocus value={medMarks + ""} style={{ fontSize: 30, flex: 1, backgroundColor: "#9db0b0" }} onChangeText={t => {
                        const tt = parseFloat(t)
                        if (!Number.isNaN(tt)) { setMedMarks(tt) }
                    }} />
                </View>
                <View style={{ marginTop: 10, marginBottom: 10, flexDirection: "row", flex: 1, alignSelf: "stretch" }}>
                    <Button textColor='white' onPress={() => { setOpen("") }} style={{ flex: 1 }}>Cancel</Button>
                    <Button loading={working} onPress={() => {
                        Save()
                    }} mode="contained" style={{ flex: 1 }}>Save Medical Marks</Button>
                </View>
            </View>
        </DModal>

    </View>
}
const FinalStudentRow = React.memo(({ expand, d, cid, year, subjects, update }) => {
    const data = d
    const st = data?.final?.status == "Pass"
    return <View style={{ padding: 5, margin: 5, borderRadius: 5, backgroundColor: st ? "#d9ffec" : data?.final?.status == "Fail" ? "#ffefed" : "" }}>
        <View style={{ flexDirection: Global.isMobile() ? "column" : "row", }}>
            <View style={{ flexDirection: "row", flex: 1 }}>
                <Text style={{ color: "black", width: 50, textAlign: "center" }} variant="headlineSmall">{data?.roll + ""}</Text>
                <View style={{ flex: 1 }}>
                    <View style={{ flexDirection: "row", alignItems: "baseline" }}>
                        <Text variant="headlineSmall" style={{ color: "black" }}>{data?.name}</Text>
                        {(data?.left == true || data?.["class" + year]?.left) ? <Text style={{ color: "red" }}>(Left)</Text> :
                            <>{cid && data?.id && <DaysPresent cid={cid} id={data?.id} />}</>
                        }
                    </View>
                </View>
            </View>
            {(data?.left !== true && !data?.["class" + year]?.left) && <View style={{ flexDirection: "row", alignItems: "center", justifyContent: "flex-end" }}>
                <Badge size={30} style={{ backgroundColor: st ? "#90EE90" : "#FF7F50", color: "black" }}>{data?.final?.status} {(data?.final?.pc && st) ? data?.final?.pc + "%" : ""}</Badge>
                <Text variant={"titleLarge"} style={{ width: 100, marginLeft: 12, marginRight: 12, color: "blue" }}> {st && data?.rank ? "Rank " + data?.rank : ""}</Text>
                <Text style={{ width: 35, color: "black" }}> {(data?.final?.finalTotal)}</Text>
            </View>}
        </View>
        {expand ? <ScrollView horizontal style={{}}>
            <View>
                <Text style={{ color: "black" }}> </Text>
                <Text style={{ color: "black" }}>પ્રથમ ક.</Text>
                <Text style={{ color: "black" }}>દ્વિતીય ક.</Text>
                <Text style={{ color: "black" }}>આંતરિક</Text>
                <Text style={{ color: "black" }}>વાર્ષિક</Text>
                <Text style={{ color: "black" }}>કુલ</Text>
                <Text style={{ color: "black" }}>કુલ(100 માંથી)</Text>
                <Text style={{ color: "black" }}>સિદ્ધિગુણ</Text>
                <Text style={{ color: "black" }}>કૃપાગુણ</Text>
            </View>
            {
                subjects?.map((s, indx) => {
                    const e = d.final[s.name]
                    let e1Med = false
                    let e2Med = false
                    if (e?.e1 == "Absent" && e?.e2 !== "Absent") {
                        e1Med = true
                    }
                    if (e?.e1 !== "Absent" && e?.e2 == "Absent") {
                        e2Med = true
                    }
                    // //console.log(s.name, e?.e1, e?.e2, e?.e1 == "Absent" && e?.e2 !== "Absent", e?.e1 !== "Absent" && e?.e2 == "Absent", e1Med, e2Med)

                    return <View key={indx} style={{ alignItems: "center", width: 60 }}>
                        <Text style={{ color: "black" }} numberOfLines={1} ellipsizeMode="clip">{s.name}</Text>
                        {e?.e1 == "Absent" ? <AbsentMarks cid={cid} what={"e1"} subject={s} student={data} update={update} /> : <Text style={{ color: "black" }}>{e?.e1} </Text>}
                        {e?.e2 == "Absent" ? <AbsentMarks cid={cid} what={"e2"} subject={s} student={data} update={update} /> : <Text style={{ color: "black" }}>{e?.e2} </Text>}
                        <Text style={{ color: "black" }}>{e?.internal}</Text>
                        {e?.e3 == "Absent" ? <AbsentMarks cid={cid} what={"e3"} subject={s} student={data} update={update} /> : <Text style={{ color: "black" }}>{e?.e3} </Text>}
                        <Text style={{ color: "black" }}>{e?.total}</Text>
                        <Text style={{ color: "black" }}>{e?.marks}</Text>
                        <Text style={{ fontWeight: "600", backgroundColor: e?.sgiven > 0 ? "#c6c6c6" : undefined, color: e?.sgiven > 0 ? "black" : "black" }}> {e?.sgiven ? e?.sgiven : ""} </Text>
                        <Text style={{ fontWeight: "600", backgroundColor: e?.kgiven > 0 ? "#c6c6c6" : undefined, color: e?.kgiven > 0 ? "black" : "black" }}> {e?.kgiven ? e?.kgiven : ""} </Text>
                    </View>
                })
            }
        </ScrollView> : null}
        <Divider />
    </View>
})

const DaysPresent = ({ cid, id }) => {

    const base = useSelector(s => s.list.PresentDays[cid]?.[id])
    const [val, setVal] = React.useState({ odays: 0, days: 0, daysWorking: false, daysSaved: false, hasData: false })
    React.useEffect(() => {
        if (base) {
            setVal(p => ({ ...p, days: base, odays: base }))
        }
    }, [base])

    async function Save() {
        if (val.days !== val.odays) {
            setVal(p => ({ ...p, daysWorking: true }))
            const ref = doc(getFirestore(), Global.PRESENTDAYS, cid)
            await setDoc(ref, { id: cid, [id]: val.days }, { merge: true })
            setVal(p => ({ ...p, daysWorking: false, daysSaved: true }))
        }
    }


    return <View style={{ flexDirection: "row", alignItems: "center" }}>
        <TextInput style={{ maxWidth: 100, backgroundColor: "transparent" }} onBlur={() => Save()} label='હાજર દિવસ' value={val.days ? val.days + "" : ""} onChangeText={(t) => {
            const tt = parseInt(t)
            if (!Number.isNaN(tt)) {
                setVal(p => ({ ...p, days: tt }))
            }
        }} />
        <ActivityIndicator animating={val.daysWorking} />
        {val.daysSaved && <IconButton iconColor='green' icon={"check"} />}
    </View>
}




function findUndefinedPaths(obj, currentPath = "") {
    let paths = [];

    // Safety check for null or non-object types to prevent errors
    console.log("paths1")

    if (obj === null || typeof obj !== "object") {
        return paths;
    }
    console.log("paths2")
    for (const key in obj) {
        // Construct the path: use [index] for arrays and .key for objects
        const isArray = Array.isArray(obj);
        const newPath = currentPath
            ? (isArray ? `${currentPath}[${key}]` : `${currentPath}.${key}`)
            : key;

        const value = obj[key];

        if (value === undefined) {
            // Found an undefined value, record the path
            paths.push(newPath);
        } else if (value !== null && typeof value === "object") {
            // It's a nested object or array; recurse deeper
            paths = [...paths, ...findUndefinedPaths(value, newPath)];
        }
    }
    console.log("paths 3", paths)
    return paths;
};